/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component } from 'react'

const { rxaget, rxChangeSlug, autoConvertTime, changeColorSVG } = global.rootRequire('classes/ulti')
const { rxgetLocal, rxsetLocal } = global.rootRequire('classes/request')
const chatDB = global.rootRequire('classes/indexedDB').default
const rxio = global.rootRequire('classes/socket').default
const workerUnread = global.rootRequire('classes/globalUnread')

class TabChatFolders_ extends Component {
  _isMounted = false
  constructor(props, context) {
    super(props, context)
    this.state = {
      tabTypeGroup: (rxgetLocal('tab_chatfolder')) ? rxgetLocal('tab_chatfolder') : '1',
      tabCnt: { total: 0, staff: 0, customer: 0 }
    }

    this.countReload = 0
  }

  componentDidMount() {
    this.resetCount()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (rxaget(nextProps, 'rxChangeGroup.status', false) !== rxaget(this.props, 'rxChangeGroup.status', false)) {
      this.countReload += 1

      if (this.countReload === 20) {
        workerUnread.resetUnread()
        this.resetCount()
        this.countReload = 0
      } else {
        let cntBadge = 0
        let cntBadgeNB = 0
        let cntBadgeKH = 0
        if (workerUnread && workerUnread.unreadFolders && workerUnread.unreadFolders.constructor === Object) {
          for (let oGroupId of Object.keys(workerUnread.unreadFolders)) {
            if (workerUnread.unreadFolders[oGroupId] === '2') {
              cntBadgeNB += 1
            }
            if (workerUnread.unreadFolders[oGroupId] === '3') {
              cntBadgeKH += 1
            }

            cntBadge = cntBadgeNB + cntBadgeKH

            if (document) { document.title = (cntBadge > 0) ? '(' + cntBadge + ') BOBACU' : 'BOBACU' }

            this.setState({
              tabCnt: { total: cntBadge, staff: cntBadgeNB, customer: cntBadgeKH }
            })

            if (window && window.ipcRenderer) {
              window.ipcRenderer.send('update_badge', cntBadge)
            }
          }
        }
      }
    }
  }

  resetCount() {
    let cntBadge = 0
    let cntBadgeNB = 0
    let cntBadgeKH = 0

    let time0 = Date.now()

    chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && (oGroup.folders.indexOf('2') !== -1))).reverse().limit(120).toArray().then(arrNB => {
      chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && (oGroup.folders.indexOf('3') !== -1))).reverse().limit(120).toArray().then(arrKH => {
        if (arrNB && arrNB.constructor === Array) {
          // cntBadgeNB = arrNB.filter(og => og.count_unread > 0).length
          for (let og of arrNB) {
            if (og.count_unread > 0) {
              cntBadgeNB += 1

              let typeFolder = (og.folders && og.folders.constructor === Array && og.folders.length > 0) ? og.folders[0] : '2'
              workerUnread.initUnread(og.group_id, typeFolder)
            } else {
              workerUnread.initUnread(og.group_id, '-1')
            }
          }
        }

        if (arrKH && arrKH.constructor === Array) {
          // cntBadgeKH = arrKH.filter(og => og.count_unread > 0).length
          for (let og of arrKH) {
            if (og.count_unread > 0) {
              cntBadgeKH += 1

              let typeFolder = (og.folders && og.folders.constructor === Array && og.folders.length > 0) ? og.folders[0] : '2'
              workerUnread.initUnread(og.group_id, typeFolder)
            } else {
              workerUnread.initUnread(og.group_id, '-1')
            }
          }
        }

        cntBadge = cntBadgeNB + cntBadgeKH

        if (document) { document.title = (cntBadge > 0) ? '(' + cntBadge + ') BOBACU' : 'BOBACU' }

        this.setState({
          tabCnt: { total: cntBadge, staff: cntBadgeNB, customer: cntBadgeKH }
        })

        if (window && window.ipcRenderer) {
          window.ipcRenderer.send('update_badge', cntBadge)
        }

      }).catch(() => { console.log("database is closed"); })
    }).catch(() => { console.log("database is closed"); })
  }

  chooseTypeGroup(type) {
    this.setState({
      tabTypeGroup: type,
      flagLoad: true
    }, () => {
      this.props.chooseTypeGroup(type)
    })
  }

  render() {
    return (<div className='header-typegroup-item'>
      <div className={(this.state.tabTypeGroup === '1') ? 'header-item-row active' : 'header-item-row'} onClick={e => this.chooseTypeGroup('1')}>
        <span>Tất cả {(this.state.tabCnt.total > 0) ? (this.state.tabCnt.total <= 9) ? <i className='tab-cnt-number'>{this.state.tabCnt.total}</i> : <i className='tab-cnt-number'>9+</i> : <></>}  </span>
      </div>
      {/* <div className={(this.state.tabTypeGroup === '2') ? 'header-item-row active' : 'header-item-row'} onClick={e => this.chooseTypeGroup('2')}>
        <span>Nội bộ {(this.state.tabCnt.staff > 0) ? (this.state.tabCnt.staff <= 9) ? <i className='tab-cnt-number'>{this.state.tabCnt.staff}</i> : <i className='tab-cnt-number'>9+</i> : <></>}</span>
      </div>
      <div className={(this.state.tabTypeGroup === '3') ? 'header-item-row active' : 'header-item-row'} onClick={e => this.chooseTypeGroup('3')}>
        <span>Khách hàng {(this.state.tabCnt.customer > 0) ? (this.state.tabCnt.customer <= 9) ? <i className='tab-cnt-number'>{this.state.tabCnt.customer}</i> : <i className='tab-cnt-number'>9+</i> : <></>}</span>
      </div> */}
    </div>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  // netaauth: state.netaauth,
  // user: state.user,
  // rxgroup: state.rxgroup,
  rxChangeGroup: state.rxChangeGroup
})

const mapDispatchToProps = {
  // chooseGroupAction,
  // changeGroupFunc
}

const TabChatFolders = connect(
  mapStateToProps,
  mapDispatchToProps
)(TabChatFolders_)

export default TabChatFolders